import React, {useEffect, useState} from 'react'
import { useParams,useNavigate } from 'react-router-dom'; // import useLocation
import './TheVisionAndMissonCard.css';

const TheVisionAndMissonCard = (selectedMenu) => {
    const { selectedOption } = useParams();
    const decodedOption = decodeURIComponent(selectedOption);
    const [selectedContent, setSelectedContent] = useState(decodedOption);
    const [selectedMenuItem, setSelectedMenuItem] = useState(decodedOption);
    const [displayFlag, setDisplayFlag] = useState(true);

    const hadleDisplayFlag = () => {
        setDisplayFlag(!displayFlag);//变更状态
    };

    const handleMenuClick = (contentId) => {
        setSelectedContent(contentId);
        setSelectedMenuItem(contentId);
        if(!(contentId==="content4-1")){
            setExpandedNewMenu(false);
        }
    };

    const handleMenuClick1 = (contentId) => {
        setDisplayFlag(!displayFlag);//变更状态
        setSelectedContent(contentId);
        setSelectedMenuItem(contentId);
        if(!(contentId==="content4-1")){
            setExpandedNewMenu(false);
        }
    };
    const handleStepNextClick = (contentId) => {
        if(contentId===null||contentId.selectedContent===""){
            setSelectedContent("content1");
        }
        const lastChar = (contentId.selectedContent).substr((contentId.selectedContent).length - 1);
        const lastDigit = parseInt(lastChar)+1;
        const newStr = "content" + lastDigit.toString();
        setSelectedContent(newStr);
        setSelectedMenuItem(newStr);
    };
    const handleStepPreClick = (contentId) => {
        const lastChar = (contentId.selectedContent).substr((contentId.selectedContent).length - 1);
        const lastDigit = parseInt(lastChar)-1;
        const newStr = "content" + lastDigit.toString();
        setSelectedContent(newStr);
        setSelectedMenuItem(newStr);
    };
    const [expandedTriangle, setExpandedTriangle] = useState(null);

    const handleToggleDetails = (triangleId) => {
        setExpandedTriangle((prevId) => (prevId === triangleId ? null : triangleId));
        setExpandedNewMenu(false);
    };
    const [expandedNewMenu, setExpandedNewMenu] = useState(null);
    const handleNewMenuClick = () => {
        setExpandedNewMenu(!expandedNewMenu);
    };

    // const navigate = useNavigate();
    const handleButtonClick = (url) => {
        window.open(url, '_blank');
    };
    // 滚动到顶部
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth", // 平滑滚动
        });
    };
    const navigate = useNavigate(); // React Router 的导航钩子
    const clickSubMenu = (value) => {
        setSelectedContent(value);
        setActiveOptionIndex(null);

        if(isNaN(value)){
            //value不是数字,则返回true ,则是需要转到其他页面去
            //for eg.   TheFoundation-1
            navigate("/"+value.split("-")[0]+"/"+value.split("-")[1]); // 跳转到指定的 URL
        } else{
            //value是数字,则返回false,则只需要当前页面转即可
            //The vision page now no need to redirect to other page
        }
    };
    // 当前选中的页码
    const [currentPage, setCurrentPage] = useState(1);

    // 当前展开子菜单的选项索引
    const [activeOptionIndex, setActiveOptionIndex] = useState(null);

    // 每个页面对应的内容和子菜单
    const pages = [
        {
            options: [
                { name: "About The Trust Wai 262", subMenu: ["Legal Status of the Trust", "Ko Matou -Nga Rangatahi Succession Planning-Presentand Future Leaders)"],
                    subDiv:["TheTrust-0","TheTrust-1"]
                },
                { name: "The Vision,Mission and Core Values of the Trust", subMenu: ["Vision, Mission, and Core Values"],subDiv:[0] },
            ]
        },
        {
            options: [
                { name: "The Foundation(Pou) of the Trust ", subMenu: ["He Wakaputanga 1835 ((Declaration of Independence)-Articles 1 to 4", "Te Tiriti o Waitangi","Te Ao Māori Views","Tino Rangatiratanga"],
                    subDiv:["TheFoundation-0","TheFoundation-1","TheFoundation-2","TheFoundation-3"] },
                { name: "Wai 262 Flora and Fauna Claim",
                    subMenu: [
                        "What is Wai 262",
                        "When did the claim begin? and why?",
                        "Profile of Claimants",
                        "Waitangi Tribunal's recommendations for the Wai 262flora and fauna claim",
                        "New Zealand's Government's Strategic Approach",
                        "Taonga introduced for Protection",
                        "About The Wai 262 Flora and Fauna Claim",
                        "The Wai 262 Report Released by The Waitangi Tribunal",
                        "What Did the Waitangi Tribunal Report Say About theWai 262 Claim?",
                        "The Waitangi Tribunal Reccomendations",
                    ] },
            ]
        },
        {
            options: [
                { name: "Contemporary Wai 262",
                    subMenu: ["The Wai 262 Contemporary Aspects of the Claim Today",
                        "Flora Taonga",
                        "Fauna Taonga",
                        "Flora and Fauna Taonga - Conclusion",
                        "Protection and Management Plan for Wai 262 Flora and FaunaContemporary Taonga",
                    ] },
                { name: "Association of New Zealand Government", subMenu: ["Sub B3-1", "Sub B3-2"] },
            ]
        },
        {
            options: [
                { name: "New Zealand Legislative Acts", subMenu: ["Sub A4-1", "Sub A4-2"] },
                { name: "International Instruments", subMenu: ["International Instruments in Association with the Wai 262-Year 1800 to Year 2024"] },
            ]
        },
        {
            options: [
                { name: "Al and Cyber Security impacts", subMenu: ["Sub A5-1", "Sub A5-2"] },
                { name: "Wai 262 Contemporary - Food Sovereignty", subMenu: ["Sub B5-1", "Sub B5-2"] },
            ]
        },
        {
            options: [
                { name: "Information Library", subMenu: ["Library Sub 1", "Library Sub 2"] },
                { name: "User Registration", subMenu: ["Registration Sub 1", "Registration Sub 2"] },
            ]
        },
        {
            options: [
                { name: "Donation for Support", subMenu: ["Library Sub 1", "Library Sub 2"] },
                { name: "Information Request", subMenu: ["Registration Sub 1", "Registration Sub 2"] },
            ]
        },
        {
            options: [
                { name: "Clothing Merchandise", subMenu: ["Sub 1", "Sub 2"] },
            ]
        },
    ];

    // 处理点击选项事件
    const handleOptionClick = (index) => {
        setActiveOptionIndex(index === activeOptionIndex ? null : index); // 点击相同选项收起子菜单
    };



    useEffect(() => {
        const decodedOption = decodeURIComponent(selectedOption);
        setSelectedContent(decodedOption);
        setSelectedMenuItem(decodedOption);
    }, [selectedOption]);
    return (
        <>
        <div className="trust-container">
            <div className="imgVison-container">
                <h1 className="h1AboutTrust-container">
                    The Vision,Mission and Core Values of the Trust Wai 262
                </h1>
                <br/>
                <div className="textTrust-container">
                    {/*Learn about the organisation`s role within the Wai 262 movement,learn about Te Tiriti O Waitangi and the concepts of He Whakaputanga.*/}
                </div>
            </div>

            <div className="options">
                {pages[currentPage - 1].options.map((option, index) => (
                    <div key={index} className="option-box">
                        <div onClick={() => handleOptionClick(index)}>{option.name}</div>
                        {/* 子菜单 */}
                        {activeOptionIndex === index && (
                            <div className="sub-menu-floating">
                                {option.subMenu.map((sub, subIndex) => (
                                    <div key={subIndex} className="sub-menu-item" onClick={(e) => clickSubMenu(option.subDiv[subIndex])}>
                                        {sub}
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                ))}
            </div>
            {/* 分页点 */}
            <div className="pagination">
                {pages.map((_, index) => (
                    <div
                        key={index}
                        className={`dot ${currentPage === index + 1 ? "active" : ""}`}
                        onClick={() => {
                            setCurrentPage(index + 1);
                            setActiveOptionIndex(null); // 切换页面时关闭子菜单
                        }}
                    ></div>
                ))}
            </div>
            <div className="Vision-content-about-wrapper">
                <div className="">
                    <div className="">
                        <div className="">
                            <div className="">
                                <h1>Mission</h1>
                                <div className="contentVision">
                                    To protect, preserve, and promote the indigenous knowledge, cultural rights, and natural
                                    resources of Maori, with a particular focus on the taonga species and
                                    mātauranga Maori (Maori knowledge) impacted by the Wai 262 flora
                                    and fauna claim. The Trust seeks to safeguard Maori sovereignty over
                                    their traditional knowledge and natural resources in the face of modern challenges such as intellectual property rights,
                                    biopiracy, and environmental degradation.
                                </div>
                            </div>
                        </div>
                        <div className="">
                            <div className="">
                                <h1>Vision</h1>
                                <div className="contentVision">
                                    A future where the rights of Māori Tino Rangatiratanga
                                    (self- determination) and kaitiakitanga (guardianship)
                                    over their flora, fauna, and intellectual property are recognized, protected,
                                    and respected, both within Aotearoa and globally. The Trust envisions a harmonious balance between cultural
                                    heritage, biodiversity, and modern development, ensuring the survival of mātauranga Maori for future generations.
                                </div>
                            </div>
                        </div>
                        <div className="">
                            <div className="">
                                <h1>Core Values</h1>
                                <div className="contentVision">
                                    To protect, preserve, and promote the indigenous knowledge, cultural rights,
                                    and natural resources of Māori, with a particular focus on the taonga species
                                    and matauranga Māori (Māori knowledge) impacted by the Wai 262 flora and fauna claim.
                                    The Trust seeks to safeguard Māori sovereignty
                                    over their traditional knowledge and natural resources in the face of modern challenges such as
                                    intellectual property rights, biopiracy, and environmental degradation.
                                </div>
                                <h3>Tino Rangatiratanga:</h3>
                                <div className="contentVision">
                                    Upholding the sovereignty and authority of Maori over their natural resources, cuture, and knowledge systems.
                                </div>
                                <h3>Kaitiakitanga:</h3>
                                <div className="contentVision">
                                    Exercising quardianship and stewardship over the environment, ensuring sustainable use of flora,fauna, and other taonga species。

                                </div>
                                <h3>Whanaungatanga:</h3>
                                <div className="contentVision">
                                    Strengthening relationships and collaborations within Maori and Non- Maori communities and with external stakeholders
                                    to support collective well-being.
                                </div>
                                <h3>Manaakitanga:</h3>
                                <div className="contentVision">
                                    Demonstrating care, respect, and hospitality towards people, land, and resources in all engagements.

                                </div>
                                <h3>Whanaungatanga:</h3>
                                <div className="contentVision">
                                    Upholding Maori lores, customs, and traditions in the governance and decision-making processes of the Trust.
                                </div>
                                <h3>Manaakitanga:</h3>
                                <div className="contentVision">
                                    Ensuring that the protection of flora, fauna, and cultural knowledge supports both ecological and cultural sustainability.
                                </div>
                            </div>
                        </div>
                    </div>
                    {/*<div className="fixed-below-scrollable">*/}
                    <div className="">
                        {/*{selectedContent !== 'content1'  && (*/}
                            {/*<label onClick={() => handleStepPreClick({selectedContent})}>Pre </label>*/}
                        {/*)}*/}
                        {/*{selectedContent !== 'content5'  && (*/}
                            {/*<label onClick={() => handleStepNextClick({selectedContent})}>*/}
                                {/*{selectedContent !== 'content1'  && (*/}
                                    {/*<label> | </label>*/}
                                {/*)}*/}
                                {/*Next </label>*/}
                        {/*)}*/}
                    </div>
                    <div className="fixed-below-scrollable">
                        Other Learning Categories
                        <label className="right-label"><sub className="triangleTrust"></sub></label>
                    </div>
                </div>
            </div>
            <div
                className="scroll-div"
                onClick={scrollToTop} // 点击事件
                title="Scroll back to top" // 鼠标悬浮提示
            ></div>
        </div>
        </>

  );
}

export default TheVisionAndMissonCard